(function () {
  function initSwiper(section) {
    if (!section || typeof Swiper === 'undefined') return;

    const swiperEl = section.querySelector('.featured-collection__swiper');
    if (!swiperEl) return;

    const slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    // 1. Retrieve the existing instance directly from the DOM element property 'swiper'.
    // This ensures we always find the previous instance even if the IIFE ran again.
    const existing = swiperEl.swiper;
    if (existing) {
      existing.destroy(true, true);
    }

    const columns = parseInt(section.dataset.columns, 10) || 4;
    
    // 2. Prevent Swiper loop mode from breaking when there aren't enough slides.
    // Loop mode requires more slides than the maximum visible slides (columns).
    const loop = section.dataset.loop !== 'false' && slides.length > columns;
    
    // 3. Clear any leftover pagination HTML/bullets before re-initializing
    const paginationEl = section.querySelector('.featured-collection__pagination');
    if (paginationEl) {
      paginationEl.innerHTML = '';
    }

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 16,
      allowTouchMove: true,
      loop,
      speed: 500,
      
      // 4. Enable observers so Swiper automatically handles layout/size updates
      observer: true,
      observeParents: true,
      
      mousewheel: false,

      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      breakpoints: {
        750: {
          slidesPerView: 2.15,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.15,
          spaceBetween: 22,
        },
        1200: {
          slidesPerView: columns,
          spaceBetween: 24,
        },
      },
    });
  }

  function destroySwiper(section) {
    const swiperEl = section?.querySelector('.featured-collection__swiper');
    if (!swiperEl) return;

    const existing = swiperEl.swiper;
    if (existing) {
      existing.destroy(true, true);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-featured-collection]').forEach(initSwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // 5. Instead of destroying and recreating on window load, just update existing instances
  window.addEventListener('load', () => {
    document.querySelectorAll('[data-featured-collection]').forEach((section) => {
      const swiperEl = section.querySelector('.featured-collection__swiper');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
      }
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-featured-collection]');
    if (section) initSwiper(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-featured-collection]');
    if (section) destroySwiper(section);
  });
})();

if (!customElements.get('featured-collection-form')) {
  customElements.define(
    'featured-collection-form',
    class FeaturedCollectionForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        this.errorEl = this.querySelector('.fc-card__error');
        this.quantityInput = this.querySelector('.quantity__input');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.error = false;

        if (document.querySelector('cart-drawer') && this.button) {
          this.button.setAttribute('aria-haspopup', 'dialog');
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }
      }

      onSubmit(event) {
        event.preventDefault();

        const moq = parseInt(this.dataset.moq, 10) || 1;
        const quantity = parseInt(this.quantityInput?.value, 10) || 0;

        this.hideError();
        this.error = false;

        if (quantity < moq) {
          this.showError(`Minimum order quantity is ${moq}`);
          return;
        }

        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.error = true;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'featured-collection-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.showError(response.description || response.message || 'Unable to add to cart.');
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'featured-collection-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            this.cart.renderContents(response);

            if (this.quantityInput) {
              this.quantityInput.value = 1;
            }
          })
          .catch(() => {
            this.error = true;
            this.showError('Something went wrong. Please try again.');
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) {
              this.button.removeAttribute('aria-disabled');
            }
          });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.classList.add('is-visible');
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.remove('is-visible');
      }
    }
  );
}
